var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"ui--messages"}},[(_vm.isOpen)?_c('modal',{staticClass:"ui ui--messages"},[_c('ElementList',{attrs:{"entries":_vm.messageButtons,"transitionName":"message"}})],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }